
import { defineComponent, onMounted, ref } from "vue";
import { setCurrentPageTitle } from "@/core/helpers/breadcrumb";
import Datatable from "@/components/kt-datatable/KTDatatable.vue";
import ApiService from "@/core/services/ApiService";

export default defineComponent({
  name: "chargeback-reasons",
  components: {
    Datatable,
  },
  props: {
    widgetClasses: String,
  },
  setup() {
    onMounted(async () => {
      setCurrentPageTitle("Chargebacks Reasons");

      loading.value = true;
      tableData.value = await getReasons(pagination.value, sort.value);
      loading.value = false;
    });

    const getReasons = async (pagination, sort) => {
      try {
        const { page, rowsPerPage } = pagination;
        const offset = (page - 1) * rowsPerPage;

        let sortParam = "";
        const { columnName, order } = sort;
        if (columnName !== "") {
          sortParam = `&sort=${columnName},${order}`;
        }
        const { data } = await ApiService.get(
          `chargebacks/reasons?offset=${offset}&limit=${rowsPerPage}${sortParam}`
        );
        return data;
      } catch (err) {
        return {
          data: [],
          meta: {
            total: 0,
          },
        };
      }
    };
    const pagination = ref({
      page: 1,
      rowsPerPage: 5,
    });
    const sort = ref({
      columnName: "",
      order: "",
    });
    const checkedReasons = ref([]);
    const tableHeader = ref([
      {
        key: "checkbox",
        sortable: false,
      },
      {
        name: "ID",
        key: "id",
        sortable: true,
      },
      {
        name: "Card Brand",
        key: "card_brand",
        sortable: true,
      },
      {
        name: "Category",
        key: "category",
        sortable: true,
      },
      {
        name: "Code",
        key: "code",
        sortable: true,
      },
      {
        name: "Time Frame",
        key: "time_frame",
        sortable: true,
      },
      {
        name: "Actions",
        key: "actions",
      },
    ]);
    const tableData = ref({
      data: [],
      meta: {
        total: 0,
      },
    });
    const loading = ref(true);
    const onCurrentChange = async (val) => {
      pagination.value.page = val;

      loading.value = true;
      tableData.value = await getReasons(pagination.value, sort.value);
      loading.value = false;
    };

    const onSort = async (val) => {
      sort.value = val;

      loading.value = true;
      tableData.value = await getReasons(pagination.value, sort.value);
      loading.value = false;
    };

    const onItemsPerPageChange = async (val) => {
      pagination.value.rowsPerPage = val;

      loading.value = true;
      tableData.value = await getReasons(pagination.value, sort.value);
      loading.value = false;
    };

    const deleteCustomer = (id) => {
      console.log(id);
    };
    return {
      tableData,
      tableHeader,
      loading,
      checkedReasons,
      pagination,

      onCurrentChange,
      onSort,
      onItemsPerPageChange,
      deleteCustomer,
    };
  },
});
